import { Schema } from "effect";

// Two levels only (spec KTD8): `fatal` blocks the document from being treated as valid structure
// (a downstream codec/pipeline cannot proceed); `warning` is a style/presentational departure the
// author should fix but that does not corrupt structure. Single source of truth — every rule and
// every ad hoc schema-failure finding picks its severity from here, never inlines the literal.
export const Severity = Schema.Literal("fatal", "warning");
export type Severity = typeof Severity.Type;
